module.exports = __webpack_public_path__ + "static/media/Rectangle 118.dae055c1.png";